import { observable } from "mobx";
import { ExternalLinkTabConfig } from "stores/wizard/config";

export class ExternalLinkTabWizardState {
  @observable
  public config: ExternalLinkTabConfig;

  constructor(config: ExternalLinkTabConfig) {
    this.config = config;
  }
}
